import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { BsFillCameraVideoFill, BsLink } from "react-icons/bs"
import { AiOutlineClockCircle } from "react-icons/ai"

export const MeetingOptions = ({ setDisplayScreen }) => {
  return (
    <Flex
      direction={"column"}
      h="80vh"
      w="100%"
      alignItems={"center"}
      justify="center"
    >
      <Flex
        bg={"#fff"}
        color="#294566"
        fontWeight={"semibold"}
        width="250px"
        shadow={"md"}
        justify="space-between"
        align={"center"}
        p="15px"
        fontSize={"16px"}
        borderRadius={"10px"}
        cursor="pointer"
        onClick={() => setDisplayScreen("create-meeting")}
      >
        <BsFillCameraVideoFill color="#000000" size={26} />
        <span>Create Instant Meeting</span>
      </Flex>
      <Flex
        bg={"#1392E6"}
        color="#fff"
        fontWeight={"semibold"}
        width="250px"
        shadow={"md"}
        // justify="center"
        align={"center"}
        p="15px"
        borderRadius={"10px"}
        cursor="pointer"
        fontSize={"16px"}
        my="20px"
        onClick={() => setDisplayScreen("join-meeting")}
      >
        <BsLink color="#fff" size={26} />
        <Text ml="40px">Join Meeting</Text>
      </Flex>

      <Flex
        bg={"#fff"}
        color="#294566"
        fontWeight={"semibold"}
        width="250px"
        shadow={"md"}
        align={"center"}
        p="15px"
        borderRadius={"10px"}
        cursor="pointer"
        fontSize={"16px"}
        onClick={() => setDisplayScreen("schedule-meeting")}
      >
        <AiOutlineClockCircle color="#000000" size={26} />
        <Text ml="20px">Schedule Meeting</Text>
      </Flex>
    </Flex>
  );
};
